import { authFetch } from "~/services/fetch";
import { parseWarehouseCheckout, type RawWarehouseCheckout } from "../interface";
import type { createWarehouseCheckinprops, createWarehouseCheckoutProps } from "../interface/createCheckout";

export async function getWarehouseCheckoutById(id: number) {
  const response = await authFetch({
    url: `/warehouse-checkout/${id}`,
    method: 'GET',
  });
  return parseWarehouseCheckout(response.data as RawWarehouseCheckout);
}

export async function createWarehouseCheckout({equipments, materials, warehouseId, receivedByUserId }: createWarehouseCheckoutProps) {
  const response = await authFetch({
    url: '/warehouse-checkout/checkout',
    method: 'POST',
    data: {
      warehouse_id: warehouseId,
      received_by_user_id: receivedByUserId,
      equipments,
      materials
    },
  });

  return response;
}

export async function createWarehouseCheckin({id, equipments, materials }: createWarehouseCheckinprops) {
  const response = await authFetch({
    url: `/warehouse-checkout/checkin/${id}`,
    method: 'PUT',
    data: {
      id: id,
      equipments,
      materials
    }
  })

  return response;
}
